import { render, staticRenderFns } from "./layoutPage.vue?vue&type=template&id=ae3c85bc&scoped=true&"
import script from "./layoutPage.vue?vue&type=script&lang=js&"
export * from "./layoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3c85bc",
  null
  
)

export default component.exports